import { observable } from 'mobx'
import { persist } from 'mobx-persist'

export class SidebarState {
    @persist
    @observable
    public collapsed: boolean = false
}
